import { useTranslation } from 'react-i18next'
import { AnimatedContainer, Anchor, Button, ErrorIcon, SuccessIcon } from '@percent/lemonade'
import { HELP_LINK } from '@percent/cause-dashboard/constants/support'
import styles from '../agentVerificationDocuments/agentVerificationDocumentsStatus/AgentVerificationDocumentsStatus.module.scss'
import { PartnerBanner } from '../agentVerificationDocuments/partnerBanner/PartnerBanner'

type ValidationRequestDocumentsStatusProps =
  | { status: 'submitted'; partnerBanner?: string | null }
  | { status: 'closed'; partnerBanner?: string | null }
  | { status: 'loadError'; onRetry: () => void }

export const ValidationRequestDocumentsStatus = (props: Readonly<ValidationRequestDocumentsStatusProps>) => {
  const { t } = useTranslation()

  const renderMessage = () => {
    switch (props.status) {
      case 'submitted':
        return (
          <>
            <h5>{t('validationRequestDocuments.submitted.title')}</h5>
            <p>{t('validationRequestDocuments.submitted.description')}</p>
          </>
        )
      case 'closed':
        return (
          <>
            <h5>{t('validationRequestDocuments.closed.title')}</h5>
            <p>
              {t('validationRequestDocuments.closed.description')}{' '}
              <Anchor href={HELP_LINK} target="_blank" rel="noreferrer" fz="inherit" className={styles.supportLink}>
                {new URL(HELP_LINK).host}
              </Anchor>
            </p>
          </>
        )
      case 'loadError':
        return (
          <>
            <h5>{t('agentVerificationDocuments.status.expired.title')}</h5>
            <p>{t('errorMessage.internalSystemError')}</p>
            <Button onClick={props.onRetry}>{t('typography.smartApply.tryAgain')}</Button>
          </>
        )
    }
  }

  return (
    <div className={styles.documentsStatusContainer} data-testid={`validation-request-documents-${props.status}`}>
      {props.status !== 'loadError' && <PartnerBanner banner={props.partnerBanner} />}
      <div className={styles.iconContainer}>
        <AnimatedContainer>{props.status === 'submitted' ? SuccessIcon : ErrorIcon}</AnimatedContainer>
      </div>
      {renderMessage()}
    </div>
  )
}
